const warned = {};

export function deprecated(msg, shouldThrow) {
	if (warned[msg]) return;
	console.error('[DraftMaster] 已弃用：' + msg);
	if (shouldThrow) {
		throw msg;
	}
	warned[msg] = true;
}



// WEBPACK FOOTER //
// ./lib/helpers/deprecated.js